// generated by genversion
export var version = '3.2.0';
//# sourceMappingURL=version.js.map